import * as React from 'react';
import { Trans } from 'react-i18next';
import { Text } from '@wix/design-system';
import s from './Cycles.scss';

export const AscendBundleIncludedNote: React.FC<{ isInSale: boolean }> = ({
  isInSale,
}) => {
  return (
    <Text
      className={s.ascendBundleNote}
      dataHook='ascend-bundle-note'
      size='small'
    >
      <Trans
        i18nKey='subscription_page.ascend_bundle'
        components={{
          colored: (
            <span className={isInSale ? s.saleOrange : s.defaultGreen} />
          ),
        }}
      />
    </Text>
  );
};
